export { default } from './WhyMR.vue';